import {
  modelFilterName,
  manufacturerModelFilterName,
  modelVariantFilterName,
  variantFilterName,
} from '@/helpers/search-client/filterNames';

export default {
  methods: {
    /**
     * Remove a variants if the model or no longer exists in the customer selection
     * @param {array} values array of the selected models
     * !TODO might move if this file becomes larger
     * Currently being used by the Makes and Models filter
     * @return null
     */
    removeSelectedVariants(values = []) {
      const selectedVariants = this.searchCriteria[variantFilterName];
      if (!selectedVariants) return;

      const availableVariants = this.filterOptions[modelVariantFilterName].items
        .filter((n) => values.indexOf(n.label) !== -1)
        .reduce((a, b) => a.concat(b.variants), [])
        .map((n) => n.label);

      const updatedVariants = selectedVariants.filter((n) => availableVariants.indexOf(n) !== -1);
      this.updateSearchCriteria(updatedVariants, variantFilterName);
    },
    /**
     * Remove a model if the manufacturer or no longer exists in the customer selection
     * @param {array} values array of the selected manufacturer
     * @return null
     */
    removeSelectedModels(values = []) {
      const selectedModels = this.searchCriteria[modelFilterName];
      if (!selectedModels) return;

      const availableModels = this.filterOptions[manufacturerModelFilterName].items
        .filter((n) => values.indexOf(n.label) !== -1)
        .reduce((a, b) => a.concat(b.models), [])
        .map((n) => n.label);

      const updatedModels = selectedModels.filter((n) => availableModels.indexOf(n) !== -1);
      this.updateSearchCriteria(updatedModels, modelFilterName);
    },
  },
};
